import { Link as RouterLink } from 'react-router-dom';
import { Alert, AlertIcon, AlertTitle, Box, Button } from '@chakra-ui/react';
import { IRecordedInterviewEntry } from 'types';
import { Breadcrumbs, CustomHeading, IBreadcrumbLink } from 'shared-components';
import { MainColumn } from '../../../molecules/MainColumn';
import { useTranslation } from "react-i18next";

interface IDeletedInterviewProps {
  interview: IRecordedInterviewEntry;
  breadcrumbItems: IBreadcrumbLink[];
}

export default function DeletedInterview(props: IDeletedInterviewProps) {
    const { t } = useTranslation('common');
  return (
    <MainColumn>
      <Breadcrumbs items={props.breadcrumbItems} />

      <Box>
        <CustomHeading level="h1" mt={4} mb={4}>
          {props.interview.interviewName}
        </CustomHeading>

        <Alert status="error" mb={4}>
          <AlertIcon />

          <Box>
            <AlertTitle>{t('common:sorryThisInterviewHasBeenDeleted')}</AlertTitle>
          </Box>
        </Alert>

        <Button as={RouterLink} to={props.breadcrumbItems[1].to}>
          {t('common:returnToStudentPage')}
                          </Button>
      </Box>
    </MainColumn>
  );
}
